import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, watch } from 'vue';
  import { useStore } from 'vuex';
  import { AppGetters } from '@store/App/getters';

  import { useHideMobileHeader } from '@/composables/useHideMobileHeader';
  import { META_THEME_COLOR } from '@/consts/skins.const';
  import { AppActions } from './store/App/actions';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  const { dispatch, getters } = useStore();

  dispatch(AppActions.GetBrand);
  const brand = computed(() => getters[AppGetters.GetBrand]);

  const displayProgressBarColor = useHideMobileHeader();
  const colorVariables = computed(() => META_THEME_COLOR[brand.value]);
  const mobileMetaContentColor = computed(() => (displayProgressBarColor.value ? colorVariables.value.secondary : colorVariables.value.primary));

  watch(mobileMetaContentColor, (newColor) => document.querySelector('meta[name="theme-color"]')?.setAttribute('content', newColor), { immediate: true });

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createBlock(_component_RouterView, {
    class: _normalizeClass(`theme-${brand.value}`)
  }, null, 8, ["class"]))
}
}

})